/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Card, Row, Col, ProgressBar } from 'react-bootstrap';
import { StarIcon } from '@heroicons/react/solid';

export interface IRatingsWidgetProps {
  title: string;
  averageRating?: number;
  footerPrefix?: string;
  totalRating: string;
  footerSuffix?: string;
}

export const RatingsWidget = ({
  title,
  averageRating,
  footerPrefix,
  totalRating,
  footerSuffix,
}: IRatingsWidgetProps) => {
  const Review = (props) => {
    const { starsCount } = props;

    return (
      <Row className="d-flex align-items-center mb-2">
        <Col
          xs={2}
          color="gray"
          className="d-flex align-items-center fw-bold px-0 small"
        >
          {starsCount}
          <StarIcon className="icon icon-xs text-warning ms-1" />
        </Col>
        <Col xs={10} className="px-0">
          <ProgressBar
            min={0}
            max={50}
            now={starsCount * 10}
            variant="primary"
            className="rounded progress-lg mb-0"
          />
        </Col>
      </Row>
    );
  };
  const _renderAverageRatingIf = () => {
    if (averageRating) {
      return <h3 className="fs-1 fw-extrabold mb-1">{averageRating}</h3>;
    }
  };
  const _renderStars = () => {
    return (
      <div className="mb-2">
        {[1, 2, 3, 4, 5].map((item, index) => {
          const _class = `icon icon-sm ${
            index + 1 > averageRating ? 'text-grey' : 'text-warning'
          }`;
          return <StarIcon key={`average-star-${index}`} className={_class} />;
        })}
      </div>
    );
  };
  const _renderFooterIf = () => {
    return (
      <small>
        {`${footerPrefix} `}
        <span color="dark" className="fw-bold">
          {totalRating}
        </span>
        {` ${footerSuffix}`}
      </small>
    );
  };

  const _renderReview = () => {
    return (
      <Col xs={12} md={7} className="mt-3 mt-md-0">
        <Col xs={12}>
          <Review starsCount={5} />
          <Review starsCount={4} />
          <Review starsCount={3} />
          <Review starsCount={2} />
          <Review starsCount={1} />
        </Col>
      </Col>
    );
  };

  if (title) {
    return (
      <>
        <Card border="0" className="shadow">
          <Card.Body>
            <Row className="d-block d-md-flex align-items-center">
              <Col xs={12} md={5}>
                <h2 className="fs-5 fw-normal mb-1">{title}</h2>
                {_renderAverageRatingIf()}
                {_renderStars()}
                {_renderFooterIf()}
              </Col>
              {_renderReview()}
            </Row>
          </Card.Body>
        </Card>
      </>
    );
  }
};

RatingsWidget.defaultProps = {
  footerPrefix: 'Based on',
  footerSuffix: 'ratings',
};
